module.exports = __webpack_public_path__ + "static/media/doc03.3dd26ce8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/doc03.png
// module id = 55
// module chunks = 0